import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CustomerPortalAvailabilityPdfQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  window: Types.PortalAvailabilityWindow;
}>;


export type CustomerPortalAvailabilityPdfQuery = { __typename?: 'Query', customerPortalAvailabilityPdf?: { __typename?: 'ReportPdfPayload', success: boolean, pdfBase64?: string | null, errorMessage?: string | null } | null };


export const CustomerPortalAvailabilityPdfDocument = new TypedDocumentString(`
    query CustomerPortalAvailabilityPdf($tenantId: String!, $window: PortalAvailabilityWindow!) {
  customerPortalAvailabilityPdf(tenantId: $tenantId, window: $window) {
    success
    pdfBase64
    errorMessage
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CustomerPortalAvailabilityPdf: build.query<CustomerPortalAvailabilityPdfQuery, CustomerPortalAvailabilityPdfQueryVariables>({
      query: (variables) => ({ document: CustomerPortalAvailabilityPdfDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCustomerPortalAvailabilityPdfQuery, useLazyCustomerPortalAvailabilityPdfQuery } = injectedRtkApi;
